import { Factory } from 'rosie';
import './lib/uuid';

Factory.define('CustomChannelMessageIncomingAttachment').extend('Uuid');

Factory.define('CustomChannelMessageIncomingAttachmentWithDefaults')
  .extend('CustomChannelMessageIncomingAttachment')
  .attr('attachmentId', 'some-id')
  .attr('contentType', 'text/plain')
  .attr('filename', 'some-facebook-attachment.txt')
  .attr('type', 'file');
